<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Sydney Markets Induction</h4>
          </md-card-header>
          <md-card-content>
            <guest-induction-form />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import GuestInductionForm from "../Forms/GuestInductionForm.vue";
export default {
  components: {
    GuestInductionForm
  }
};
</script>
